import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { STATICPAGE_HEADER_COLOR_CLASSES } from "npmlinks-constants";

import { getRandomNumberWithRange } from "../../utils";
import StaticPageTitle from "../../component/StaticPageTitle";
import StaticPageContent from "../../component/StaticPageContent";
import CustomerCareLeftNav from "./CustomerCareLeftNav";

@inject("CommonStore")
@observer
class CustomerCare extends Component {
  render() {
    const { isDesktop } = this.props.CommonStore;
    const headerColorDecider =
      !global.isServer && isDesktop
        ? STATICPAGE_HEADER_COLOR_CLASSES[getRandomNumberWithRange()]
        : "nw-customercare-color";

    // This is avoid the server side rendering
    if (global && global.isServer) {
      return null;
    }

    return (
      <GridContainer>
        <GridRow>
          <GridColumn>
            <StaticPageTitle.component
              title="Frequently asked questions"
              className={headerColorDecider}
            />
          </GridColumn>
        </GridRow>
        <GridRow className="nwc-main-content-wrapper">
          <GridColumn className="nwc-grid-col-sm-3">
            <CustomerCareLeftNav.component />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-9 nw-customercare-content">
            <StaticPageContent.component fetchDescription="customercare" className="nw-customercare-content" />
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

export { default as CustomerCareLeftNav } from "./CustomerCareLeftNav";

CustomerCare.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: CustomerCare.wrappedComponent,
  component: CustomerCare,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/CustomerCare/index.js